import { useCallback, useEffect, useRef } from 'react';
import { useStore } from 'effector-react';
import { $compareState, $compareStateApi } from '../compareStores';
import ImgHandler from './img-h-handler.png';

export function ModeSplitWidgets() {
  const { left } = useStore($compareState);
  const ref = useRef<HTMLImageElement>(null);

  const updatePosition = useCallback((clientX: number) => {
    if (ref.current?.parentElement) {
      const { left: parentLeft, width: parentWidth } =
        ref.current.parentElement.getBoundingClientRect();
      let newLeft = (clientX - parentLeft) / parentWidth;
      if (newLeft < 0) newLeft = 0;
      if (newLeft > 1) newLeft = 1;
      $compareStateApi.setLeft(newLeft);
    }
  }, []);

  const handleMouseDown = useCallback(
    (event: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
      event.preventDefault();
      const handleMouseMove = (moveEvent: MouseEvent) => {
        updatePosition(moveEvent.clientX);
      };
      const handleMouseUp = () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };

      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    },
    [updatePosition]
  );

  useEffect(() => {
    return () => {
      document.removeEventListener('mousemove', () => {});
      document.removeEventListener('mouseup', () => {});
    };
  }, []);

  return (
    <>
      <div
        className="pointer-events-auto absolute flex h-full w-[6px] cursor-col-resize items-center justify-center"
        ref={ref}
        style={{ left: `calc(${left * 100}% - 3px)` }}
        onMouseDown={handleMouseDown}
      >
        <div className="absolute h-full w-2 bg-white" />
        <img
          className="h-30 w-[6px] cursor-col-resize"
          draggable={false}
          src={ImgHandler}
          alt=""
        />
      </div>
      <div className="absolute left-10 top-10 whitespace-nowrap rounded bg-black-black/50 p-[6px] text-sm">
        原始场景
      </div>
      <div
        className="absolute top-10 whitespace-nowrap rounded bg-black-black/50 p-[6px] text-sm"
        style={{ left: `calc(${left * 100}% + 10px)` }}
      >
        对比场景
      </div>
    </>
  );
}
